import uuid from 'uuid/v4';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ResizeAware from 'react-resize-aware';
import DynamicDataGrid from '../common/DynamicDataGrid/DynamicDataGrid';
import DnDItemTypes from '../common/DynamicDnD/DnDItemTypes';

import { numberWithCommas, checkWeightType } from '../../util/CommonUtils';

import * as quickReportsActions from '../../actions/quickReportsActions';
import * as dictionaryActions from '../../actions/dictionaryActions';

const tooltipFormatter = (row) => <div title={row.row.tooltip}>{row.value}</div>;


 const commaFormatter = ({ value }) => <div>{numberWithCommas(value)}</div>;

commaFormatter.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

tooltipFormatter.propTypes = {
  value: PropTypes.string,
};

const getGridColumns = (titleColumnName, quickreportsWeightTypes) => [
  { key: 'title', name: titleColumnName, editable: true, formatter: tooltipFormatter
},
  { key: 'sample', name: 'Sample', width: '', formatter: commaFormatter },
  {
    key: 'weighted',
    name: `Weighted ${checkWeightType(quickreportsWeightTypes)}`,
    width: 140,
    formatter: commaFormatter,
  },
];

class BaseAndTarget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      quickReportsBase: props.quickReportsBase || [],
      quickReportsTarget: props.quickReportsTarget || [],
      baseTargetContainerWidth: null,
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.quickReportsBase !== nextProps.quickReportsBase) {
      this.setState({ quickReportsBase: nextProps.quickReportsBase || [] });
    }
    if (this.props.quickReportsTarget !== nextProps.quickReportsTarget) {
      this.setState({ quickReportsTarget: nextProps.quickReportsTarget || [] });
    }
  }

  handleGridDrop = (dropItem, dropItemType, componentGridCategory) => {
    if (
      dropItemType === DnDItemTypes.DnD_ITEM_TYPE_2 ||
      dropItemType === DnDItemTypes.DnD_ITEM_TYPE_4
    ) {
      const selectedKeywords = [];
      const selectedNames = [];

      if (dropItemType === DnDItemTypes.DnD_ITEM_TYPE_2) {
        selectedKeywords.push(dropItem.selectedNodes[0].keyword);
        selectedNames.push(dropItem.selectedNodes[0].shortText);
      } else {
        selectedKeywords.push(dropItem.selectedNodes[0].expression);
        selectedNames.push(dropItem.selectedNodes[0].title);
      }

      const sampleWeightedParams = {
        sourceGrid: componentGridCategory,
        targetGrid: componentGridCategory,
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: this.props.quickReportsStudy.pn,
        weightType: this.props.quickreportsWeightTypes.wt,
        divisor: this.props.quickreportsWeightTypes.dv,
        expressionList: selectedKeywords,
        gridData: [],
        selectedNames,
      };
      this.props.getSampleWeighted(sampleWeightedParams);
    } else if (
      dropItem.gridCategory === 'RecycleGrid' &&
      dropItem.selectedEntries.length > 0
    ) {
      const draggedItem = {
        id: uuid(),
        title: dropItem.selectedEntries[0].title,
        originalTitle: dropItem.selectedEntries[0].originalTitle,
        sample: dropItem.selectedEntries[0].sample,
        weighted: dropItem.selectedEntries[0].weighted,
        keyword: dropItem.selectedEntries[0].keyword,
      };
      this.props.quickReportsActions.updateSampleWeighted(
        [draggedItem],
        componentGridCategory
      );
    }
  };

  handleBaseAndTargetContainerResize = dimensions => {
    this.setState({ baseTargetContainerWidth: dimensions.width });
  };

  render() {
    return (
      <div className="expanded large-12 base-target-tables-wrapper">
        <div
          className=" medium-6 large-6 columns padding-left-0"
          style={{ paddingRight: '10px' }}
        >
          <div className="crosstab-grids-header">
            {/* <div className="large-1 display-inline text-right">
              <GenericButton
                name=""
                btnStyle="fa fa-pencil-square-o"
                onBtnClick={() => { this.dictionaryCodingBox.show(); }}
              />
            </div> */}
            <button
              type="submit"
              label="Clear"
              className="clear-btn"
              onClick={() =>
                this.props.quickReportsActions.clearSampleWeighted(
                  'BaseDataGrid'
                )
              }
              disabled={this.state.quickReportsBase.length === 0}
            />
          </div>
          <ResizeAware
            style={{ position: 'relative', width: '100%' }}
            onlyEvent
            onResize={this.handleBaseAndTargetContainerResize}
          >
            <DynamicDataGrid
              gridCategory="BaseDataGrid"
              dataScreen="QuickReports"
              className="base-target-data-grid"
              gridHeight={70}
              gridWidth={this.state.baseTargetContainerWidth}
              rows={this.state.quickReportsBase}
              columns={getGridColumns(
                'Base',
                this.props.quickreportsWeightTypes
              )}
              onGridDrop={this.handleGridDrop}
              onDataUpdate={rows =>
                this.props.quickReportsActions.updateSampleWeighted(
                  [...rows],
                  'BaseDataGrid'
                )
              }
              minimunRows={1}
              isRowsDraggable={false}
              isCellSelectable
            />
          </ResizeAware>
        </div>
        <div
          className="medium-6 large-6 columns padding-right-0"
          style={{ paddingLeft: '10px' }}
        >
          <div className="crosstab-grids-header">
            {/* <div className="large-1 display-inline text-right">
              <GenericButton
                name=""
                btnStyle="fa fa-pencil-square-o"
                onBtnClick={() => { this.dictionaryCodingBox.show(); }}
              />
            </div> */}
            <button
              type="submit"
              label="Clear"
              className="clear-btn"
              onClick={() =>
                this.props.quickReportsActions.clearSampleWeighted(
                  'TargetDataGrid'
                )
              }
              disabled={this.state.quickReportsTarget.length === 0}
            />
          </div>
          <ResizeAware
            style={{ position: 'relative', width: '100%' }}
            onlyEvent
            onResize={this.handleBaseAndTargetContainerResize}
          >
            <DynamicDataGrid
              gridCategory="TargetDataGrid"
              dataScreen="QuickReports"
              className="base-target-data-grid"
              gridHeight={70}
              gridWidth={this.state.baseTargetContainerWidth}
              rows={this.state.quickReportsTarget}
              columns={getGridColumns(
                'Target',
                this.props.quickreportsWeightTypes
              )}
              onGridDrop={this.handleGridDrop}
              onDataUpdate={rows =>
                this.props.quickReportsActions.updateSampleWeighted(
                  [...rows],
                  'TargetDataGrid'
                )
              }
              minimunRows={1}
              isRowsDraggable={false}
              isCellSelectable
            />
          </ResizeAware>
        </div>
      </div>
    );
  }
}

BaseAndTarget.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  activeAccountId: PropTypes.number,
  quickReportsStudy: PropTypes.shape({
    pn: PropTypes.number,
    dv: PropTypes.number,
    wt: PropTypes.number,
    sd: PropTypes.string,
  }),
  quickReportsActions: PropTypes.shape({
    updateSampleWeighted: PropTypes.func,
    clearSampleWeighted: PropTypes.func,
  }),
  getSampleWeighted: PropTypes.func,
  gridData: PropTypes.shape({}),
  quickReportsBase: PropTypes.arrayOf(PropTypes.object),
  quickReportsTarget: PropTypes.arrayOf(PropTypes.object),
  quickreportsWeightTypes: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
  }),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    quickReportsBase: state.quickReports.BaseDataGridData,
    quickReportsTarget: state.quickReports.TargetDataGridData,
    quickreportsWeightTypes: state.study.quickreportsWeightTypes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    quickReportsActions: bindActionCreators(quickReportsActions, dispatch),
    dictionaryActions: bindActionCreators(dictionaryActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BaseAndTarget);
